import { render, staticRenderFns } from "./ToplogoCustomer.vue?vue&type=template&id=5d0df6ef&scoped=true&"
import script from "./ToplogoCustomer.vue?vue&type=script&lang=js&"
export * from "./ToplogoCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ToplogoCustomer.vue?vue&type=style&index=0&id=5d0df6ef&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0df6ef",
  null
  
)

export default component.exports